import { 
  EuiCallOut,
  EuiFlexGroup,
  EuiFlexItem,
  EuiPage,
  EuiPageBody,
  EuiPageContent,
  EuiPageContentBody,
  EuiPageHeader,
  EuiPageHeaderSection,
  EuiTitle,} from '@elastic/eui';
import React from 'react';
import DetallePartesContainer from './container';

export const DetallePartesView = (props) =>{
  return (
    <EuiPage>
    <EuiPageBody component="div">
      <EuiPageHeader>
          <EuiFlexGroup alignItems='center'>
            <EuiFlexItem>
              <EuiTitle size="l"><h1>DETALLE DE PARTES</h1></EuiTitle>
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
            <EuiCallOut size="s"
            title="Si no visualizas columnas, modifícalas en el apartado Mi Configuración."
            iconType="iInCircle" />
            </EuiFlexItem>
          </EuiFlexGroup>
      </EuiPageHeader>
      <EuiPageContent>
        <EuiPageContentBody>
          <DetallePartesContainer/>
        </EuiPageContentBody>
      </EuiPageContent>
    </EuiPageBody>
  </EuiPage>
  )
}
export default DetallePartesView;